import React, { useState } from "react";
import axios from "axios";
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleViewUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get("http://localhost:5000/admin/users", {
        headers: {
          "x-user-id": 11, // replace with your admin user ID dynamically if needed
        },
      });
      setUsers(response.data.users);
    } catch (err) {
      console.error("Error fetching users:", err);
      alert("Failed to fetch users");
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h5" gutterBottom>Admin: View Users</Typography>
      <Button variant="contained" color="primary" onClick={handleViewUsers} disabled={loading}>
        {loading ? "Loading..." : "View Users"}
      </Button>

      {users.length > 0 && (
        <Table style={{ marginTop: "20px" }}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Last Post</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.id}</TableCell>
                <TableCell>{user.username}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.lastPost || "No posts"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default AdminUsers;
